import { render, staticRenderFns } from "./BBCheckboxGroup.vue?vue&type=template&id=ad2497b0&"
import script from "./BBCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./BBCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports